import { defineStore } from 'pinia'

import type { CommonStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useCommonStore = defineStore('common-kanban', {
  state: (): CommonStore => ({
    loading: false,
  }),
  actions,
  getters,
})
